import LocationDetailsList from "./LocationDetailsList";

export default {
    list: LocationDetailsList
};
